import Button, { ButtonProps } from '@mui/material/Button';
import { darken, styled } from '@mui/material/styles';

import '../types/theme.d';
import { getThemeStateColors } from '../utils/ThemeUtils';

// Added darken for hover effect

export const ButtonWithText = styled(Button)<ButtonProps>(({ theme }) => {
  const themeColors = getThemeStateColors(theme);

  // Safely access borderRadius from theme, with proper typing
  const borderRadius = (() => {
    const rootOverride = theme.components?.MuiButton?.styleOverrides
      ?.root as any;
    if (rootOverride && rootOverride.borderRadius !== undefined) {
      return rootOverride.borderRadius;
    }
    return theme.shape?.borderRadius ?? 4;
  })();

  return {
    // Basic button styling
    height: '40px',
    borderRadius,
    padding: '12px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    // Text styling
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '0.75px',
    textTransform: 'uppercase',

    // State styling
    boxShadow:
      '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',

    // Enabled state styles
    color: themeColors.button.text,
    backgroundColor: themeColors.button.default,
    '&:hover': {
      backgroundColor: darken(themeColors.button.default, 0.1),
    },

    // Active state
    '&:active': {
      backgroundColor: darken(themeColors.button.default, 0.2),
      boxShadow: 'none',
    },

    // Focus state
    '&:focus': {
      boxShadow: `0 0 0 3px ${themeColors.button.default}${Math.round(
        themeColors.opacity.focus * 255
      ).toString(16)}`,
    },

    // Disabled state styles
    '&:disabled': {
      backgroundColor: themeColors.button.disabled.background,
      color: themeColors.button.disabled.text,
      boxShadow: 'none',
    },
  };
});
